import { useNavigate, useParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetPlanI8nEditPageParams = (): { hotelID: string; planID: string; langCode: LangCode } => {
	const { hotelID, planID, langCode } =
		useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.I18N>>();

	const navigate = useNavigate();

	if (!(hotelID && planID && langCode)) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
		planID: planID!,
		langCode: langCode! as LangCode,
	};
};
